module.exports = __webpack_public_path__ + "static/img/banner5.b04b443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner5.png
// module id = /Oaz
// module chunks = 1